<template>
  <span
    v-if="currentStatus && currentStatus !== statusName.not_set"
    class="status text-xs font-medium rounded-lg tracking-wide inline-block px-2 py-1"
    :style="{
      'color': currentColor,
      'background-color': hexToRgba(currentColor, 0.1)
    }"
    >{{ currentStatus }}</span
  >
</template>

<script>
import EventBus from "event_bus";

export default {
  props: ["status", "color", "status-name"],
  data: function () {
    return {
      currentStatus: this.status,
      currentColor: this.color
    };
  },

  mounted() {
    this.onStatusChanged = ({ name, color }) => {
      this.currentStatus = name;
      this.currentColor = color;
    };
    EventBus.$on("post_status_changed", this.onStatusChanged);
  },

  beforeDestroy() {
    EventBus.$off("post_status_changed", this.onStatusChanged);
  },

  filters: {
    humanize: function (str) {
      if (str) {
        return str.replace(/_/g, " ");
      } else {
        return;
      }
    },
  },

  methods: {
    hexToRgba(hex, alpha = 1) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  },
};
</script>

<style scoped>

</style>
